<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-container *ngIf="boardGroups.length">
    <h2>{{ 'TASKS.TEXT.GROUPS' | translate }}</h2>
    <app-accordion
            (emitEditHeaderName)="editGroupName($event)"

            [accordionData]="{
					allHeaders: allAccordionHeaders,
					templateAccordionBody: containerTemplate
				}"
    ></app-accordion>
</ng-container>
<ng-template #containerTemplate let-data="data">
    <button (click)="deleteBoardGroup(data.groupId)"
            *ngIf="!data.boards.length && currentMember?.project_setting?.is_project_admin"
            class="btn btn-danger float-end mb-2"
    >
        <span>{{ 'BUTTON_TEXT.DELETE' | translate }}</span>
        <i class="bi bi-trash ms-1" ngbTooltip="{{ 'BUTTON_TEXT.DELETE' | translate }}"></i>
    </button>

    <div *ngIf="data else loading" class="dash-list" style="margin-bottom: unset">
        <ng-container *ngTemplateOutlet="boardTemplate; context: {data: data.boards, showButtons: true}"></ng-container>
        <div *ngIf="currentMember?.project_setting?.is_project_admin" class="items">
            <div (click)="openAddBoardModal(addBoardView, data.groupId)" class="add-board">
                <i class="bi bi-plus-circle"></i>
                <span style="width: 60%">{{ 'TASKS.BUTTONS.ADD_BOARD' | translate }}</span>
            </div>
        </div>
    </div>
</ng-template>

<h2 class="mt-3">{{ 'TASKS.TEXT.BOARDS' | translate }}</h2>
<div [class.justify-content-between]="isView" class="dash-list">
    <ng-container *ngTemplateOutlet="boardTemplate; context: {data: boards, showButtons: true}"></ng-container>
</div>
<strong *ngIf="!boards.length">{{ 'EMPTY_LISTS.BOARDS' | translate }}</strong>

<!--  Рендер приток бизнес-процессов  -->
<ng-template #boardTemplate let-data="data" let-showButtons="showButtons">
    <div (click)="selectDash(board, showButtons)"
         *ngFor="let board of data; let i = index"
         [attr.data-board-index]="i"
         [class.wrap]="boardWrap[i]"
         class="items gbo_shadow">
        <div class="flex-display justify-content-between">
            <h2 [ngbTooltip]="board.alias" class="board-alias">
                [{{ board.alias }}]
            </h2>
            <div *ngIf="showButtons && !isView">
                <i (click)="editGroupToNull($event, board)"
                   *ngIf="board.group_id && currentMember?.project_setting?.is_project_admin"
                   class="bi bi-x-lg settings"
                   data-action='deleteBoardFromGroup'
                   ngbTooltip="{{ 'TASKS.TOOLTIPS.REMOVE_BP' | translate }}"
                ></i>
                <i (click)="openBoardSettings($event, board)"
                   *ngIf="(board.rights && board.rights.is_edit_settings === 'allowed') ||
                            currentMember?.project_setting?.is_project_admin"
                   class="bi bi-gear-fill settings"
                   data-action='openSettings'
                   ngbTooltip="{{ 'TASKS.TOOLTIPS.BOARD_SETTINGS' | translate }}"
                ></i>
                <i (click)="selectBoard($event, board, settingsView)" class="bi bi-sliders settings"
                   data-action='openMemberSettings'
                   ngbTooltip="{{ 'TASKS.TOOLTIPS.SETTINGS' | translate }}"
                ></i>
            </div>
        </div>
        <div data-action='openBoard'>
            <i class="{{board.icon}} icon"></i>

            <div>
                <strong #name
                        [ngbTooltip]="board.name"
                        [style]="{'-webkit-line-clamp':
				                    (boardWrap[i] ?
				                    'unset' : 2)
				                  }"
                        class="nameBoard hide_text"
                >
                    {{ board.name }}
                </strong>

                <span #description
                      [style]="{'-webkit-line-clamp':
				                    (boardWrap[i] ?
				                    'unset' :
				                    name.offsetHeight === 48 ?
				                    (board.icon ? 1 : 4) :
				                    (board.icon ? 2 : 6))
								}"
                      class="description hide_text"
                >
					<small [innerHtml]="board.description" style="display: block;"></small>
				</span>
            </div>
        </div>
        <button (click)="wrapBoard($event, i)"
                *ngIf="name.scrollHeight + description.scrollHeight > 139"
                class="btn btn-link btn-block more"
                data-action='moreButton'
        >
            {{ "TASKS.TEXT." + !boardWrap[i] ? 'MORE' : 'HIDE' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #settingsView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-board-settings-modal
                (emitReloading)="emitReloading.emit($event)"
                [board]="selectedBoard"
        ></app-board-settings-modal>
    </div>
</ng-template>

<ng-template #addBoardView let-modal>
    <app-button-modal-close [modalSize]="'xl'" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div *ngIf="showAddBoardTemplate else loading" class="dash-list justify-content-center">
            <ng-container
                    *ngTemplateOutlet="boardTemplate; context: {data: boards, showButtons: false}"
            ></ng-container>
            <div class="items">
                <div (click)="taskService.eminOnOpenCreateBoardModal.emit(editGroupId)"
                     *ngIf="currentMember?.project_setting?.is_project_admin"
                     class="add-board">
                    <i class="bi bi-plus-circle"></i>
                    <span style="width: 60%">{{ 'TASKS.BUTTONS.CREATE_BOARD' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
